import { api } from "./http-client";
import { TopUpPackage, CreateTopUpPackageDto, UpdateTopUpPackageDto } from "../interfaces/topup-package.interface";

export const topupPackagesService = {
  list: async (): Promise<TopUpPackage[]> => {
    const res = await api.request<{ data: TopUpPackage[] }>({
      url: "/admin/points/top-up-packages",
      method: "GET",
    });
    const body = res.data as { data: TopUpPackage[] } | TopUpPackage[];
    return Array.isArray(body) ? body : body.data;
  },

  create: async (dto: CreateTopUpPackageDto): Promise<TopUpPackage> => {
    const res = await api.request<TopUpPackage>({
      url: "/admin/points/top-up-packages",
      method: "POST",
      data: dto,
    });
    return res.data;
  },

  update: async (id: string, dto: UpdateTopUpPackageDto): Promise<TopUpPackage> => {
    const res = await api.request<TopUpPackage>({
      url: `/admin/points/top-up-packages/${id}`,
      method: "PUT",
      data: dto,
    });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({
      url: `/admin/points/top-up-packages/${id}`,
      method: "DELETE",
    });
  },
};
